<template>
  <database-layout>
    <div v-if="exportDownloaded" class="space-y-4">
      <base-heading>Encrypted database export is downloading...</base-heading>
      <p>If you are using this to sync between CMSs, import the downloaded file with the previously shown encryption key into the CMS you wish to sync with.</p>
    </div>
    <div v-else class="space-y-4">
      <div>
        <base-input :disabled="true" label="Encryption Key" v-model="exportEncryptionKey" />
        <small slot="helperText" class="form-text text-muted">Save this encryption key before proceeding, it will only be shown once and it is required to decrypt the contents of the database.</small>
      </div>
      <div>
        <base-checkbox v-model="keyConfirmed">I have copied the encryption key</base-checkbox>
      </div>
      <base-button v-if="keyConfirmed" tag="a" target="_blank" :href="route('cms.database.export.download')" @click="exportDownloaded = true">Export</base-button>
      <base-button v-else :disabled="true">Export</base-button>
    </div>
  </database-layout>
</template>
<script>
import DatabaseLayout from './Layout.vue'
import Form from '../../components/Form';
export default {
  components: {
    DatabaseLayout,
    ...Form,
  },
  data() {
    return {
      keyConfirmed: false,
      exportDownloaded: false,
    }
  },
  props: {
    exportEncryptionKey: {
      type: String,
      default: '',
    }
  },
}
</script>
